import firebase from 'firebase';
var fire;

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.0/8 are considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

class FirebaseClass {
    constructor(){
        var firebaseConfig = {
            apiKey: "AIzaSyB8qPMjpdghpaIkTNfykzPl0TbFDVR-p2M",
            authDomain: "picnic-92bc2.firebaseapp.com",
            databaseURL: "https://picnic-92bc2.firebaseio.com",
            projectId: "picnic-92bc2",
            storageBucket: "picnic-92bc2.appspot.com",
            messagingSenderId: "86525819208",
            appId: "1:86525819208:web:494c3047ebd4fc1d145b7d",
            measurementId: "G-4X8YET9FEW"
        };
        fire = firebase.initializeApp(firebaseConfig);
    }
    setCurrentScreen(screenName){
        if (!isLocalhost){
            fire.analytics().setCurrentScreen(screenName);
        }
    } 
    logEvent(eventName,object){
        if (!isLocalhost){
            fire.analytics().logEvent(eventName,object);
        }
    } 
}
const fb = new FirebaseClass();
export default fb;